export default __webpack_public_path__ + "static/media/flow_1.ac8a97e2.jpg";